export const DEFAULT_LANG = "en";
export const ACCESS_TOKEN = "NOS_ACCESS_CLIENT_TOKEN";
export const USER_REVENUECAT_ID = "USER_REVENUECAT_ID";

export const PHONE_PATTERN = "+1 (###) ### - ####";
export const DATE_FORMAT = "MM/dd/yyyy";
export const MONTH_DATE_FORMAT = "MMM-dd-yyyy";
export const MANIFEST_DATE_FORMAT = "MMM dd, yyyy";
export const ISO_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"; // this is .net compatible
